import { useCallback, useEffect, useState } from 'react';
import { Page } from '../../types/storybook';

export interface EditorSelectionDomain {
  selectedElement: string | null;
  selectElement: (elementId: string | null) => void;
  clearSelection: () => void;
}

export const pageContainsElement = (page: Page | undefined, elementId: string): boolean => (
  Boolean(page?.textElements.some(element => element.id === elementId))
  || Boolean(page?.imageElements.some(element => element.id === elementId))
);

export const resolvePageSelection = (
  page: Page | undefined,
  elementId: string | null
): string | null => (
  elementId && pageContainsElement(page, elementId) ? elementId : null
);

export const useEditorSelectionDomain = (currentPage?: Page): EditorSelectionDomain => {
  const [selectedElement, setSelectedElement] = useState<string | null>(null);

  useEffect(() => {
    setSelectedElement(current => resolvePageSelection(currentPage, current));
  }, [currentPage, selectedElement]);

  const selectElement = useCallback((elementId: string | null) => {
    setSelectedElement(elementId);
  }, []);

  const clearSelection = useCallback(() => setSelectedElement(null), []);

  return { selectedElement, selectElement, clearSelection };
};
